class UkenaHomeCarousel {
  constructor(root) {
    this.root = root;
    this.slides = [...root.querySelectorAll('[data-home-slide]')];
    this.dots = [...root.querySelectorAll('[data-home-dot]')];
    this.pauseButton = root.querySelector('[data-home-pause]');
    this.pauseLabel = root.querySelector('[data-home-pause-label]');
    this.index = 0;
    this.interval = null;
    this.userPaused = false;
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.bind();
    this.update(0);
    this.syncAutoplay();
  }

  bind() {
    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        this.update(index);
        this.restartAutoplay();
      });
    });

    this.pauseButton?.addEventListener('click', () => {
      this.userPaused = !this.userPaused;
      this.pauseButton.setAttribute('aria-pressed', String(this.userPaused));
      this.pauseLabel.textContent = this.userPaused ? 'Play' : 'Pause';
      this.syncAutoplay();
    });

    this.root.addEventListener('pointerenter', () => this.stopAutoplay());
    this.root.addEventListener('pointerleave', () => this.syncAutoplay());
    this.root.addEventListener('focusin', () => this.stopAutoplay());
    this.root.addEventListener('focusout', event => {
      if (!this.root.contains(event.relatedTarget)) this.syncAutoplay();
    });
    this.reducedMotion.addEventListener?.('change', () => this.syncAutoplay());
    document.addEventListener('visibilitychange', () => this.syncAutoplay());

    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0]?.isIntersecting;
        this.syncAutoplay();
      }, { threshold: .35 });
      this.observer.observe(this.root);
    } else {
      this.inView = true;
    }
  }

  update(nextIndex) {
    this.index = (nextIndex + this.slides.length) % this.slides.length;
    this.slides.forEach((slide, index) => {
      const active = index === this.index;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', String(!active));
      slide.toggleAttribute('inert', !active);
    });
    this.dots.forEach((dot, index) => {
      if (index === this.index) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
  }

  startAutoplay() {
    if (this.interval || this.slides.length < 2) return;
    this.interval = window.setInterval(() => this.update(this.index + 1), 5000);
  }

  stopAutoplay() {
    if (!this.interval) return;
    window.clearInterval(this.interval);
    this.interval = null;
  }

  syncAutoplay() {
    const canPlay = !this.userPaused && !this.reducedMotion.matches && !document.hidden && this.inView !== false;
    if (canPlay) this.startAutoplay();
    else this.stopAutoplay();
  }

  restartAutoplay() {
    this.stopAutoplay();
    this.syncAutoplay();
  }
}

document.querySelectorAll('[data-ukena-home-carousel]').forEach(root => {
  if (!root.dataset.homeCarouselReady) {
    root.dataset.homeCarouselReady = 'true';
    new UkenaHomeCarousel(root);
  }
});
